import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'equals',
    standalone: false
})
export class EqualsPipe<T> implements PipeTransform {
    public transform(value: T, compareTo: T, shouldEqual: boolean = true): boolean {
        return (value === compareTo) === shouldEqual;
    }
}
